import jsPDF from "jspdf";
import moment from "moment";

export function generateQuotationPDF(data) {
  const doc = new jsPDF("p", "mm", "a4");
  const pw = doc.internal.pageSize.getWidth();
  const lx = 14;
  let y = 15;

  // Header
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD", pw / 2, y, { align: "center" });
  y += 6;
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text("Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP", pw / 2, y, { align: "center" });
  y += 4;
  doc.text("Phone No.0884-2326661, 62, Mobile No.9494127893", pw / 2, y, { align: "center" });
  y += 4;
  doc.text("Email: purchase@sleipl.com, lalitharice@gmail.com | GSTIN: 37AAKCS3233N1ZX", pw / 2, y, { align: "center" });
  y += 7;

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("QUOTATION  #" + (data.code || ""), pw / 2, y, { align: "center" });
  y += 3;
  doc.line(10, y, pw - 10, y);
  y += 6;

  // Details
  doc.setFontSize(9);
  const rx = pw / 2 + 10;
  const addRow = (lbl1, val1, lbl2, val2) => {
    doc.setFont("helvetica", "bold");
    doc.text(lbl1, lx, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(val1 || ""), lx + 28, y);
    doc.setFont("helvetica", "bold");
    doc.text(lbl2, rx, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(val2 || ""), rx + 28, y);
    y += 6;
  };

  addRow("Created By:", (data.createdby?.fullname || "") + " (" + (data.createdby?.username || "") + ")", "Total Price:", "Rs. " + (data.grand_total || data.total || ""));
  addRow("RFQ Code:", data.requestforquotation_code || "", "Delivery Date:", moment(data.deliverydate).format("DD-MM-YYYY"));
  addRow("Vendor:", data.vendor?.name || "", "Submitted On:", moment(data.createdon).format("DD-MM-YYYY"));

  y += 1;
  doc.line(10, y, pw - 10, y);
  y += 5;

  // Table header
  const cols = [
    { label: "S.No", w: 10, align: "center" },
    { label: "Item Name", w: 48, align: "left" },
    { label: "Qty", w: 20, align: "center" },
    { label: "Base Price", w: 20, align: "center" },
    { label: "Disc %", w: 15, align: "center" },
    { label: "Price", w: 18, align: "center" },
    { label: "Tax Type(%)", w: 25, align: "center" },
    { label: "Tax Amt", w: 18, align: "center" },
    { label: "Gross", w: 18, align: "center" },
  ];

  const startX = 10;
  const rowH = 7;

  // Draw header
  doc.setFillColor(240, 240, 240);
  doc.rect(startX, y - 4, pw - 20, rowH, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  let cx = startX;
  cols.forEach((c) => {
    doc.text(c.label, cx + c.w / 2, y, { align: "center" });
    cx += c.w;
  });
  y += rowH - 1;
  doc.line(startX, y - 3, pw - 10, y - 3);

  // Draw rows
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  const items = data.qitems || [];
  items.forEach((item, i) => {
    if (y > 270) {
      doc.addPage();
      y = 15;
    }
    cx = startX;
    const vals = [
      String(i + 1),
      (item.product?.name || "") + (item.make ? " | " + item.make : ""),
      (item.qty || "") + " " + (item.unit?.name || ""),
      String(item.baseprice || ""),
      (item.discountpercent || "0") + "%",
      String(item.price || ""),
      (parseInt(item.taxtype) === 1 ? "Incl" : "Excl") + "(" + (item.tax?.name || "") + ")",
      String(item.taxamount || ""),
      String(item.gross || ""),
    ];
    cols.forEach((c, j) => {
      const txt = vals[j] || "";
      const truncated = txt.length > 30 ? txt.substring(0, 28) + ".." : txt;
      if (c.align === "left") {
        doc.text(truncated, cx + 1, y);
      } else {
        doc.text(truncated, cx + c.w / 2, y, { align: "center" });
      }
      cx += c.w;
    });
    y += rowH;
    doc.line(startX, y - 3, pw - 10, y - 3);
  });

  y += 3;

  // Terms
  if (data.terms) {
    doc.line(10, y, pw - 10, y);
    y += 5;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text("Terms & Conditions:", lx, y);
    y += 5;
    doc.setFont("helvetica", "normal");
    doc.splitTextToSize(data.terms, pw - 30).forEach((line) => {
      if (y > 280) { doc.addPage(); y = 15; }
      doc.text(line, lx + 4, y);
      y += 4;
    });
  }

  // Description
  if (data.description) {
    y += 2;
    doc.line(10, y, pw - 10, y);
    y += 5;
    doc.setFont("helvetica", "bold");
    doc.text("Other Details:", lx, y);
    y += 5;
    doc.setFont("helvetica", "normal");
    doc.splitTextToSize(data.description, pw - 30).forEach((line) => {
      if (y > 280) { doc.addPage(); y = 15; }
      doc.text(line, lx + 4, y);
      y += 4;
    });
  }

  doc.save("Quotation_" + (data.code || "Report") + ".pdf");
}
